import React, { useState, Fragment, FC } from 'react';
import { FormDataConsumer, useTranslate } from 'react-admin';

import { EditButton } from '~/components';
import { EditForm } from '~/components/ra';
import ConfigurationForm, { l } from '~/resources/ledgers/mambu/components/ConfigurationForm';
import { useSetMambuLedgerConfiguration } from '~/hooks/ledgers';
import onError from '~/errorsHandler';
import { MambuConfiguration } from '~/types';
import FullscreenDrawer from '~/components/FullscreenDrawer';

interface ConfigurationEditProps {
  resource: string;
  record?: MambuConfiguration;
  onOpenDrawer?: () => void;
}

const ConfigurationEdit: FC<ConfigurationEditProps> = (props) => {
  const { resource, record, onOpenDrawer } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`fields.${key}`));

  const { mutateAsync: setConfiguration } = useSetMambuLedgerConfiguration();

  const handleSubmit = (newRecord: MambuConfiguration) => {
    const newRecordWithDefaultValues = {
      ...newRecord,
      ...(!newRecord.clientRoleKeys ? { clientRoleKeys: {} } : {}),
      ...(!newRecord.groupRoleKeys ? { groupRoleKeys: {} } : {}),
      ...(!newRecord.productTypeKeys ? { productTypeKeys: {} } : {}),
      transactionTransferMirroring: {
        ...newRecord.transactionTransferMirroring,
        ...(!newRecord.transactionTransferMirroring.transitChannelKeys
          ? { transitChannelKeys: {} }
          : {}),
        ...(!newRecord.transactionTransferMirroring.transitDepositKeys
          ? { transitDepositKeys: {} }
          : {}),
      },
    };

    setConfiguration(newRecordWithDefaultValues)
      .then(() => {
        handleClose();
      })
      .catch(onError);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    onOpenDrawer?.();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <Fragment>
      <EditButton onClick={handleOpen} />
      <FullscreenDrawer heading={t('editConfigurationDetails')} open={open} onClose={handleClose}>
        <EditForm resource={resource} record={record} onSubmit={handleSubmit} style={fullWidth}>
          <FormDataConsumer>{() => <ConfigurationForm />}</FormDataConsumer>
        </EditForm>
      </FullscreenDrawer>
    </Fragment>
  );
};

const fullWidth = { width: '100%', padding: 28, paddingTop: 0 };

export default ConfigurationEdit;
